import { render, staticRenderFns } from "./CustomBuyButton.vue?vue&type=template&id=7f87940c&scoped=true&"
import script from "./CustomBuyButton.vue?vue&type=script&lang=js&"
export * from "./CustomBuyButton.vue?vue&type=script&lang=js&"
import style0 from "./CustomBuyButton.vue?vue&type=style&index=0&id=7f87940c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87940c",
  null
  
)

export default component.exports